import { BlockedRegionsConfig } from '../../donation/getDonationPartnerConfig/getDonationPartnerConfig.types'
import { toGsResponse } from '../../goodstack'
import { PartnerConfig } from '../../config/config.types'

import { QueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'

export type GetPartnerRestrictedVolunteeringConfigResponse = {
  data: {
    restricted_countries_for_volunteering?: PartnerConfig<
      'restricted_countries_for_volunteering',
      { blockedRegions: BlockedRegionsConfig[] }
    >
  }
  object: string
}

export const getPartnerRestrictedVolunteeringConfig: QueryFn<[string], BlockedRegionsConfig[]> = async (client, _) => {
  const response = await client
    .get<GetPartnerRestrictedVolunteeringConfigResponse>(`v1/partner/volunteering/config`, {
      withCredentials: true,
      validateStatus: code => [200, 404].includes(code)
    })
    .then(r => toGsResponse(r.status, r.data))
    .then(r => (r.result === 'success' ? r : undefined))
    .catch(() => undefined)

  return response?.data.restricted_countries_for_volunteering?.value?.blockedRegions ?? []
}
